import { ThunkDispatch } from '@reduxjs/toolkit';
import { FormikProps } from 'formik';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import { Action } from 'redux';
import { PROMOTIONS } from 'Routes/constants';
import { RootState } from 'slices';
import {
  setShowAllValidateErrors,
  setCountSubmit,
  resetPromotion,
} from 'slices/promotions/reducer';
import { PromoFormValues } from 'types/promotion/promotionTypes';

const FormActionButtons = ({
  dispatch,
  formik,
}: {
  dispatch: ThunkDispatch<RootState, void, Action>;
  formik: FormikProps<PromoFormValues>;
}) => {
  const history = useNavigate();
  return (
    <Row>
      <Col xs={12} sm={6} className="text-center">
        <div className="mb-3">
          <Row>
            <Col xs={1} sm={3}></Col>
            <Col xs={5} sm={3}>
              <Button
                block
                outline
                color="dark"
                className="btn btn-ghost-light material-shadow-none"
                id="promo-cancel"
                type="button"
                onClick={() => {
                  dispatch(setShowAllValidateErrors(false));
                  dispatch(resetPromotion());
                  history(PROMOTIONS.LIST);
                }}
              >
                {t('Btn_Cancel')}
              </Button>
            </Col>

            <Col xs={5} sm={3}>
              <Button
                block
                color="success"
                type="submit"
                id="promo-save"
                disabled={formik.isSubmitting}
                onClick={async () => {
                  await formik.setTouched(
                    Object.keys(formik.initialValues).reduce(
                      (acc, key) => ({ ...acc, [key]: true }),
                      {}
                    )
                  );
                  dispatch(setShowAllValidateErrors(true));
                  dispatch(setCountSubmit());
                }}
              >
                {t('Btn_Save')}
              </Button>
            </Col>
            <Col xs={1} sm={3}></Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default FormActionButtons;
